export default __webpack_public_path__ + "static/content-2-9741b0fa1202614516d4d7d17827e34a.jpg";